import { getScene7VideoExistsUrl } from '../constants';
import { typedFetch } from './typedFetch';

export async function checkScene7VideoExists(
    productMasterId: number
): Promise<boolean> {
    const videoExistsUrl = getScene7VideoExistsUrl(productMasterId);
    // response will include exists=0 or exists=1 according to scene7 docs
    const response = (await typedFetch<string>(videoExistsUrl)) || '';
    return response.includes('exists=1');
}
